import { render, staticRenderFns } from "./LiberdadeEM.vue?vue&type=template&id=36eaaa85&scoped=true"
import script from "./LiberdadeEM.vue?vue&type=script&lang=js"
export * from "./LiberdadeEM.vue?vue&type=script&lang=js"
import style0 from "./LiberdadeEM.vue?vue&type=style&index=0&id=36eaaa85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eaaa85",
  null
  
)

export default component.exports